import React from 'react'
import Topbar from '../layouts/Topbar'
import PageHeader from '../components/PageHeader'
import CommonTable from '../../Admin/components/Common_table'
import Addcatalogue from '../components/Add_catalogue'
import { useGlobalContext } from '../../context/Context'
import SubHeader from '../components/SubHeader'
import PageFilter from '../components/PageFilter'

const Product = () => {
const data = {
    "columns": [
      {
        "label": "S.No",
        "field": "sno",
      },
      {
        "label": "Sub-Category",
        "field": "sub-category",
      },
      {
        "label": "Sub-Sub-Category",
        "field": "sub-sub-category",
      },
      {
        "label": "no of views",
        "field": "views",
      },
      {
        "label": "Design Type",
        "field": "design",
      },
      {
        "label": "Design Pic",
        "field": "pic",
      },
      {
        "label": "Upload Date",
        "field": "date",
      },
      {
        "label": "Actions",
        "field": "action",
      },
    ],
    "rows": [
      {
        "sno": "1",
        "sub-category": "Western",
        "sub-sub-category": "Blazer",
        "views": 2,
        "design": "Blazer Suit",
        "pic": "https://imgs.search.brave.com/0Nl2IbAWiqr-SlFJ0V_pr5MwcoD2BJOAsZrF3MSQEhc/rs:fit:860:0:0:0/g:ce/aHR0cHM6Ly9tLm1l/ZGlhLWFtYXpvbi5j/b20vaW1hZ2VzL0kv/MzFDZUNzK3FUaUwu/anBn",
        "date": "11/7/2024",
        "action": "11/7/2024",
        "status": true
      },
      {
        "sno": "2",
        "sub-category": "Ethnic",
        "sub-sub-category": "Kurta Pyjama",
        "views": 4,
        "design": "Kurta",
        "pic": "https://imgs.search.brave.com/gBeaAEZ5r6seM-DUUhhTaVpMcekS2iKt6s3cvKEYGAQ/rs:fit:860:0:0:0/g:ce/aHR0cHM6Ly9pbWFn/ZXMuY2JhemFhci5j/b20vaW1hZ2VzL05h/dnktQmx1ZS1FbWJy/b2lkZXJlZC1LdXJ0/YS1QeWphbWEtU2V0/LUtQTVNHUjEwNzAt/dS5qcGc",
        "date": "11/7/2024",
        "action": "11/7/2024",
        "status": true
      },
      {
        "sno": "3",
        "sub-category": "Wedding",
        "sub-sub-category": "Coat",
        "views": 7,
        "design": "Suit",
        "pic": "https://imgs.search.brave.com/9pZAKlNtvmQC7tPy6vI9epGcy2vTlemaQRONrHErHE8/rs:fit:860:0:0:0/g:ce/aHR0cHM6Ly9pLnBp/bmltZy5jb20vb3Jp/Z2luYWxzL2Y4LzZh/L2FiL2Y4NmFhYjA4/NTkyNjk1MDg3NTli/ZjA4ZWQwMGE0YmFj/LmpwZw",
        "date": "11/7/2024",
        "action": "11/7/2024",
        "status": true
      },
      {
        "sno": "4",
        "sub-category": "Western",
        "sub-sub-category": "Trouser",
        "views": 1,
        "design": "Trouser",
        "pic": "https://imgs.search.brave.com/mAASeJCd0NWU_k1txX2vK-OjDEZbCwVZ6ZxVKIR2UoA/rs:fit:860:0:0:0/g:ce/aHR0cHM6Ly9pbWcu/ZnJlZXBpay5jb20v/cHJlbWl1bS1waG90/by9tb2RlbC13ZWFy/cy1iZWlnZS10cm91/c2VyLWZyb20tYnJh/bmQtcy1zcHJpbmct/Y29sbGVjdGlvbl8z/MjY1MzMtMjIzNC5q/cGc_c2l6ZT02MjYm/ZXh0PWpwZw",
        "date": "11/7/2024",
        "action": "11/7/2024",
        "status": true
      },
      {
        "sno": "5",
        "sub-category": "Event",
        "sub-sub-category": "Patiala",
        "views": 3,
        "design": "Trouser",
        "pic": "https://imgs.search.brave.com/BJ9FTq2o7vwqeM8V9W2jCsFbb8FPTP8ioQWSVfjYgQs/rs:fit:860:0:0:0/g:ce/aHR0cHM6Ly9tLm1l/ZGlhLWFtYXpvbi5j/b20vaW1hZ2VzL0kv/NzEtU1NqUFJjK0wu/anBn",
        "date": "11/7/2024",
        "action": "11/7/2024",
        "status": true
      },
    ]
  }

    const filterOptions = ['All','Ethnic','Wedding Outfits','Western Outfits','Event Costumes']
    const { openDialog, setOpenDialog } = useGlobalContext();
    const title = {name:"Products",subheading:"Add to the catalogue and view products",search:"Search products",button:"Add Products"}

  return (
    <>
        <Topbar />
        <section className='admin-catalogue'>
            <PageHeader title={title} openDialog={openDialog} setOpenDialog={setOpenDialog} />
            <SubHeader menu={'products'} sort={'products'} options={filterOptions} />
            <CommonTable columns={data.columns} rows={data.rows} />
            <PageFilter />
            <Addcatalogue openDialog={openDialog} setOpenDialog={setOpenDialog} />
        </section>
    </>
  )
}

export default Product
